<template>
  <div>
    <v-select label="Tipo de programación"
              class="mt-3"
              :items="availableScheduleTypes"
              name="type"
              v-model="draft.scheduleType"
    ></v-select>

    <v-layout row wrap align-center>
      <span>Desde</span>
      <div class="d-inline-flex">
        <v-menu
            ref="startDate"
            v-model="menus.startDate"
            :close-on-content-click="false"
            :nudge-right="40"
            :nudge-top="150"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on">
              <v-icon class="mr-1">event</v-icon>
              {{ startLabel }}
            </v-btn>
          </template>
          <v-date-picker
              ref="picker"
              locale="es-es"
              :first-day-of-week="1"
              @input="handleStartDate"
              v-model="draft.startDate"
          >
            <v-spacer></v-spacer>
            <v-btn v-if="draft.startDate"
                   flat color="error" @click="delete draft.startDate">Borrar
            </v-btn>
          </v-date-picker>
        </v-menu>
        <v-menu
            ref="startTime"
            v-if="draft.startDate"
            v-model="menus.startTime"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on">
              {{ draft.startTime }}
            </v-btn>
          </template>
          <v-time-picker v-model="draft.startTime" format="24hr"></v-time-picker>
        </v-menu>
      </div>
      <span>hasta</span>
      <div class="d-inline-flex">
        <v-menu
            ref="startDate"
            v-model="menus.endDate"
            :close-on-content-click="false"
            :nudge-right="40"
            :nudge-top="150"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on">
              <v-icon class="mr-1">event</v-icon>
              {{ endLabel }}
            </v-btn>
          </template>
          <v-date-picker
              ref="picker"
              locale="es-es"
              :first-day-of-week="1"
              @input="handleEndDate"
              v-model="draft.endDate"
          >
            <v-spacer></v-spacer>
            <v-btn v-if="draft.endDate"
                   flat
                   color="error"
                   @click="delete draft.endDate">Borrar
            </v-btn>
          </v-date-picker>
        </v-menu>
        <v-menu
            ref="endTime"
            v-if="draft.endDate"
            v-model="menus.endTime"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on">
              {{ draft.endTime }}
            </v-btn>
          </template>
          <v-time-picker v-model="draft.endTime" format="24hr"></v-time-picker>
        </v-menu>
      </div>
    </v-layout>

    <v-select
        v-if="draft.scheduleType === SCHEDULE_TYPE_RECURRENT"
        label="Los días"
        name="days"
        v-model="draft.days"
        :items="availableDays"
        multiple
        placeholder="Todos los dias"
    ></v-select>

    <v-layout row wrap align-center v-if="draft.scheduleType === SCHEDULE_TYPE_RECURRENT">
      <v-checkbox label="Todo el dia"

                  v-model="durationAllDay"></v-checkbox>
      <v-layout row wrap align-center v-if="!durationAllDay">
        <span>Desde las</span>
        <v-menu
            ref="periodStart"

            v-model="menus.periodStart"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on">
              {{ draft.periodStart || '00:00'}}
            </v-btn>
          </template>
          <v-time-picker v-model="draft.periodStart" format="24hr"></v-time-picker>
        </v-menu>
        <span>hasta las</span>
        <v-menu
            ref="periodEnd"
            v-model="menus.periodEnd"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on">
              {{ draft.periodEnd || '23:59'}}
            </v-btn>
          </template>
          <v-time-picker
              v-model="draft.periodEnd"
              format="24hr"
              max="23:59"
              :min="draft.periodStart || '00:00'"
          ></v-time-picker>
        </v-menu>
      </v-layout>
    </v-layout>

  </div>
</template>

<script>
import NxForm from '@/modules/form/Form';
import { SCHEDULE_TYPE_RECURRENT, SCHEDULE_TYPE_ONCE } from '@/modules/board/dayparting/config';
import moment from 'moment';
import { omitBy, isNil } from 'lodash';
import { RRule } from 'rrule';

export default {
  name: 'nx-dayparting-event-editor',
  extends: NxForm,
  data() {
    return {
      SCHEDULE_TYPE_ONCE,
      SCHEDULE_TYPE_RECURRENT,
      durationAllDay: true,
      menus: {
        startDate: false,
        endDate: false,
        startTime: false,
        endTime: false,
        periodStart: false,
        periodEnd: false,
      },
    };
  },
  computed: {
    availableScheduleTypes() {
      return [
        { text: 'Una vez', value: SCHEDULE_TYPE_ONCE },
        { text: 'Recurrente', value: SCHEDULE_TYPE_RECURRENT },
      ];
    },
    availableDays() {
      return [
        { text: 'Lunes', value: RRule.MO.toString() },
        { text: 'Martes', value: RRule.TU.toString() },
        { text: 'Miercoles', value: RRule.WE.toString() },
        { text: 'Jueves', value: RRule.TH.toString() },
        { text: 'Viernes', value: RRule.FR.toString() },
        { text: 'Sabado', value: RRule.SA.toString() },
        { text: 'Domingo', value: RRule.SU.toString() },
      ];
    },
    startLabel() {
      if (!this.draft.startDate) {
        return 'Ahora';
      }
      return moment(this.draft.startDate).format('YYYY-MM-DD');
    },
    endLabel() {
      if (!this.draft.endDate) {
        return 'Fin de los tiempos';
      }
      return moment(this.draft.endDate).format('YYYY-MM-DD');
    },
    dtstart() {
      if (!this.draft.startDate) {
        return moment().startOf('day').toDate();
      }
      return new Date(`${this.draft.startDate} ${this.draft.startTime}`);
    },
    until() {
      if (!this.draft.endDate) {
        return null;
      }
      return new Date(`${this.draft.endDate} ${this.draft.endTime}`);
    },
    byweekday() {
      if (this.draft.scheduleType === SCHEDULE_TYPE_ONCE) {
        return [];
      }
      const dayToRRuleDay = {
        MO: RRule.MO,
        TU: RRule.TU,
        WE: RRule.WE,
        TH: RRule.TH,
        FR: RRule.FR,
        SA: RRule.SA,
        SU: RRule.SU,
      };
      return this.draft.days.map(day => dayToRRuleDay[day]) || [];
    },
    byhour() {
      if (!this.durationAllDay) {
        return [moment(this.draft.periodStart || '00:00', 'HH:mm').hour()];
      }
      // Recurrent all day events starts at 00:00 and has a 24h duration
      if (this.draft.scheduleType === SCHEDULE_TYPE_RECURRENT) {
        return 0;
      }
      return null;
    },
    byminute() {
      if (!this.durationAllDay) {
        return [moment(this.draft.periodStart || '00:00', 'HH:mm').minute()];
      }
      // Recurrent all day events starts at 00:00 and has a 24h duration
      if (this.draft.scheduleType === SCHEDULE_TYPE_RECURRENT) {
        return 0;
      }
      return null;
    },
    rrule() {
      if (this.draft.scheduleType !== SCHEDULE_TYPE_RECURRENT) {
        return null;
      }

      let freq = RRule.WEEKLY;
      if (!this.draft.days || this.draft.days.length === 0) {
        freq = RRule.DAILY;
      }

      const options = omitBy({
        freq,
        byweekday: this.byweekday,
        byhour: this.byhour,
        byminute: this.byminute,
        dtstart: this.dtstart,
        until: this.until,
        tzid: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }, val => isNil(val));

      const rrule = new RRule(options);

      return rrule.toString();
    },
    duration() {
      if (this.draft.scheduleType === SCHEDULE_TYPE_ONCE) {
        return null;
      }

      // Recurrent all day events starts at 00:00 and has a 24h duration
      if (this.durationAllDay) {
        return moment.duration(24, 'hours').toString();
      }

      const start = moment(this.draft.periodStart || '00:00', 'HH:mm');
      const end = moment(this.draft.periodEnd || '23:59', 'HH:mm');
      return moment.duration(end.diff(start)).toISOString();
    },
    event() {
      return omitBy({
        dtstart: moment(this.dtstart).format(),
        dtend: this.until ? moment(this.until).format() : null,
        duration: this.duration,
        rrule: this.rrule,
      }, val => !val);
    },
  },
  methods: {
    handleStartDate() {
      if (!this.draft.startTime) {
        this.draft.startTime = '00:00';
      }
    },
    handleEndDate(date) {
      if (!this.draft.endTime) {
        this.draft.endTime = (date === this.draft.startDate) ? '23:59' : '00:00';
      }
    },
  },
  watch: {
    draft: {
      immediate: true,
      deep: true,
      handler(val) {
        this.durationAllDay = (!val.periodEnd && !val.periodStart);
      },
    },
  },
};
</script>
